import { render, staticRenderFns } from "./ToggleServiceProduct.vue?vue&type=template&id=cbf0c3c2&scoped=true"
import script from "./ToggleServiceProduct.vue?vue&type=script&lang=js"
export * from "./ToggleServiceProduct.vue?vue&type=script&lang=js"
import style0 from "./ToggleServiceProduct.vue?vue&type=style&index=0&id=cbf0c3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf0c3c2",
  null
  
)

export default component.exports